import request from '@/api/request'

/**
 * 获取 课时-文件关联表列表
 * @param page
 * @param limit
 */

export const getPageList = (data) => {
  return request({
    url: 'product/adm/lesperiodDoc/getListPage',
    data,
    type: 'json',
    method: 'post'
  })
}

/**
 * 添加接口
 *    id  主键
 *    lesperiodId  课时id
 *    name  课件名称
 *    type  文件类型。1pdf2word3excel4rar
 *    url  下载地址
 *    sortNum  排序号
 *    remarks  备注
 *    insertBy  创建者，如果为系统初始数据填0
 *    insertDate  创建时间
 *    lastUpdateBy  最后更新者，如果为系统初始数据填0
 *    lastUpdateDate  最后更新时间
 *    delFlag  逻辑删除标记（1：显示；2：删除）
 *    version  版本号
 * */
export const addLesperiodDoc = (data) => {
  return request({
    url: 'product/adm/lesperiodDoc/addLesperiodDoc',
    data,
    type: 'json',
    method: 'post'
  })
}

/**
 * 更新接口
 * * id  主键
 * * lesperiodId  课时id
 * * name  课件名称
 * * type  文件类型。1pdf2word3excel4rar
 * * url  下载地址
 * * sortNum  排序号
 * * remarks  备注
 * * insertBy  创建者，如果为系统初始数据填0
 * * insertDate  创建时间
 * * lastUpdateBy  最后更新者，如果为系统初始数据填0
 * * lastUpdateDate  最后更新时间
 * * delFlag  逻辑删除标记（1：显示；2：删除）
 * * version  版本号
 * *
 */
export const updateLesperiodDoc = (data) => {
  return request({
    url: 'product/adm/lesperiodDoc/updateLesperiodDoc',
    data,
    type: 'json',
    method: 'post'
  })
}

/**
 * 删除
 * @param id
 */
export const removeLesperiodDoc = (data) => {
  return request({
    url: 'product/adm/lesperiodDoc/delLesperiodDoc',
    data,
    type: 'json',
    method: 'post'
  })
}
